<div class="relative flex flex-col w-full min-h-full max-h-full sm:min-w-120 md:min-w-200">
    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-gray-50 dark:bg-gray-900 border-b">
      <div class="text-2xl">
       Autouzupełnianie 
      </div>
  
      <button mat-icon-button [matDialogClose]="undefined">
        <mat-icon class="dark:text-white" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
      </button>
  
    </div>
  
    <div class="flex flex-auto overflow-hidden mb-14 sm:mb-0">
      <div class="flex flex-col flex-auto sm:mb-18 overflow-y-auto p-6">
        
        <app-autocomplete-settings [settings]="settings"></app-autocomplete-settings>
      </div>
    </div>
  
    <div class="absolute inset-x-0 bottom-0 py-4 pr-4 pl-1 sm:pr-8 sm:pl-7 border-t z-10 bg-gray-50 dark:bg-gray-900">
      <div class="flex items-end">
        <div class="ml-auto">
          <button mat-flat-button (click)="close()" class="ml-2">Zamknij</button>
        </div>
      </div>
    </div>
  </div>